import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { NDDTranslationService } from '@ndk/ng-translation';

import {
    INDDFormsI18nServiceConfigResources,
    NDDFormsI18nService,
} from '../shared/ndd-ng-forms-i18n.service';

/** Componente fieldset. */
@Component({
    selector: 'ndd-ng-form-fieldset',
    template: require('./ndd-ng-form-fieldset.component.html'),
})
export class NDDFormFieldsetComponent implements OnInit {
    /** Legenda do fieldset. */
    @Input() public controlLegend: string;

    /** Descrição do fieldset. */
    @Input() public controlDescription?: string;
    /** Define fieldset como desabilitado. */
    @Input() public controlDisabled?: boolean;
    /** Desabilita a descrição quando apresentado no mobile */
    @Input() public hideDescriptionOnMobile: boolean;
    /** Permite expandir/esconder o conteúdo. */
    @Input() public allowCollapse: boolean;

    public collapse: boolean = false;
    public titleCollapse: string;
    public titleExpand: string;

    constructor(
        private formsI18n: NDDFormsI18nService,
        private translationService: NDDTranslationService,
    ) { }

    public ngOnInit(): void {
        this.translateTitles();
    }

    public onCollapse(): void {
        if (!this.allowCollapse) { return; }

        this.collapse = !this.collapse;
    }

    private translateTitles(): void {
        if (!this.allowCollapse && !this.formsI18n.config.i18n) { return; }

        const resources: INDDFormsI18nServiceConfigResources = this.formsI18n.config.resources;
        this.titleCollapse = this.translationService.instant(resources.fieldsetCollapse);
        this.titleExpand = this.translationService.instant(resources.fieldsetExpand);
    }
}
